'use strict';

import angular from 'angular';

const popularCurrencies = [
  'EUR',
  'USD',
  'GBP'
];

const currencyOptionsFactory = (currencies) => {
  'ngInject';

  return {
    popular: currencies
      .map(currency => currency.code)
      .filter(currency => (popularCurrencies.indexOf(currency) > -1)),
    all: currencies
      .map(currency => currency.code)
      .filter(currency => popularCurrencies.indexOf(currency) === -1)
  };
};

export default angular
  .module('service.currencyOptions', [])
  .factory('currencyOptions', currencyOptionsFactory)
  .name;



// WEBPACK FOOTER //
// ./app/src/services/currency_options.service.js